<script setup>
defineOptions({
  name: 'NewAuthLayout',
})
</script>

<template>
  <div class="relative min-h-screen overflow-hidden">
    <div class="absolute inset-0">
      <img
        src="@shared/assets/svg/background.svg?url"
        alt=""
        class="relative object-cover h-full w-full"
        aria-hidden="true"
      >
    </div>

    <div class="relative z-10">
      <router-view />
    </div>
  </div>
</template>
